import styled from 'styled-components';

const EditorForm = styled.div`
  text-align: left !important;
  padding: 30px;
  width: 100%;
  display: block;

  input {
    width: 100%;
  }
`;

export default EditorForm;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditorForm/index.jsx